/* eslint-disable no-shadow */
import React, { useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { Col, Row, Button, ButtonGroup } from 'reactstrap';
import moment from 'moment';
import ConnectionTests from './ConnectionTests';
import SysInfo from './SysInfo';
import Diagnostics from './Diagnostics';
import AddSecurityCodeModal from '../../../AddSecurityCodeModal';
import { getSysInfo, inititateSysInfo } from '../../../../actions/EpikBoxes';
import * as BoxesActions from '../../../../actions/EpikBoxes';
import SwitchInfo from '../SwitchInfo';
import { ESysInfoAction } from '../../../../lib/constants';
import utils, { isAdminRole } from '../../../../lib/utils';

function InfoToolTab({
  sysinfo,
  onDetailBtn,
  speedTestInfo,
  boxDetails,
  getSysInfo,
  inititateSysInfo,
  user,
  getSystemStatus,
  getEpikBoxData,
  onReloadBox,
  speedDataInfo,
}) {
  const [active, setActive] = useState('connectionTest');
  const [stateSocket, setStateSocket] = useState(null);
  const [serialNumberDash, setSerialNumberDash] = useState('');
  const [modalStatus, setModalStatus] = useState(false);
  const [sysLoading, setSysLoading] = useState(false);
  const [speedBoxDisable, setSpeedBoxDisable] = useState(true);
  const [onPressed, setOnPressed] = useState(true);
  const token = localStorage.getItem('jwtToken') || null;

  const socketConnect = (socket, serialNumberDash) => {
    setStateSocket(socket);
    setSerialNumberDash(serialNumberDash);
  };

  const systemStatus = async () => {
    const boxId = window.location.pathname.split('/').pop();
    await getSystemStatus(token, boxId);
    await getEpikBoxData(token, boxId);
  };

  const diffMinutes = (now, end) => {
    const duration = moment.duration(now.diff(end));
    return duration.asMinutes();
  };

  useEffect(() => {
    if (boxDetails && Object.keys(boxDetails).length) {
      const currentDate = moment(new Date());
      const progressDate = moment(new Date(boxDetails?.lteTestInProgress));

      if (boxDetails?.lteSpeedtest === undefined) {
        setSpeedBoxDisable(false);
      } else if (
        !!boxDetails?.lteSpeedtest &&
        (boxDetails?.lteTestInProgress === null || !boxDetails?.lteTestInProgress)
      ) {
        setSpeedBoxDisable(false);
      } else if (boxDetails?.lteTestInProgress && diffMinutes(currentDate, progressDate) > 5) {
        setSpeedBoxDisable(false);
      } else if (boxDetails?.lteTestInProgress && diffMinutes(currentDate, progressDate) < 5) {
        setSpeedBoxDisable(true);
      }
    }
  }, [boxDetails]);

  useMemo(async () => {
    if (boxDetails && Object.keys(boxDetails).length !== 0) {
      if (active !== 'diagnostics' && stateSocket !== null) {
        stateSocket.emit('DIAGNOSTICS', {
          cleanup: true,
          serialNumber: serialNumberDash,
          ip: boxDetails.vpnAddress,
        });
      }
    }
  }, []);

  const onTabChange = tab => {
    setActive(tab);
  };

  const onReloadStatus = async () => {
    setSysLoading(true);
    await systemStatus();
    setSysLoading(false);
  };

  const onReloadSysInfo = React.useCallback(async () => {
    setSysLoading(true);
    await getSysInfo(token, boxDetails._id, ESysInfoAction.NEW);
    setSysLoading(false);
  }, [boxDetails]);

  const onInititateSysInfo = React.useCallback(async () => {
    await inititateSysInfo(token, boxDetails._id);
  });

  useEffect(() => {
    if (active === 'sysInfo') {
      onReloadSysInfo();
      setOnPressed(false);
    } else if (active === 'vswitch' && !boxDetails.myEpik) {
      setSysLoading(true);
      systemStatus();
      setSysLoading(false);
    }
  }, [active]);

  return (
    <div className="viewContainer">
      <Row>
        <Col md={12}>
          <Row
            style={{
              padding: '12px 25px 12px 12px',
              borderBottom: '1px solid #8998ac',
            }}
          >
            <Col md={{ size: '11', offset: '1' }}>
              <ButtonGroup className="tab-group" style={{ width: '100%', margin: '0px' }}>
                <Button
                  id="test-connection-tests-tab"
                  onClick={() => onTabChange('connectionTest')}
                  className={active === 'connectionTest' ? 'active' : ''}
                >
                  Connection Tests
                </Button>
                {
                  utils.filterCustomer(user?.role) ? (
                    <Button
                      onClick={() => onTabChange('vswitch')}
                      className={active === 'vswitch' ? 'active' : ''}
                      id="test-vswitch-info-tab"
                    >
                      Vswitch info
                    </Button>
                  ) : null
                }

                <Button
                  onClick={() => onTabChange('sysInfo')}
                  className={active === 'sysInfo' ? 'active' : ''}
                  id="test-sys-info-tab"
                >
                  Sys Info
                </Button>
                {!isAdminRole(user.role) && (
                  <Button
                    onClick={() => onTabChange('diagnostics')}
                    className={active === 'diagnostics' ? 'active' : ''}
                    id="test-diagnostics-tab"
                  >
                    Diagnostics
                  </Button>
                )}
              </ButtonGroup>
            </Col>
          </Row>
        </Col>
        <Col md={12}>
          <div className="epik-boxes-container" style={{ minHeight: '120px' }}>
            {active === 'sysInfo' && (
              <SysInfo userRole={user.role} sysLoading={sysLoading} sysinfo={sysinfo} onReloadInfo={onInititateSysInfo} onReloadSysInfo={onReloadSysInfo} />
            )}
            {active === 'diagnostics' && (
              <Diagnostics user={user} boxDetails={boxDetails} socketConnect={socketConnect} />
            )}
            {active === 'vswitch' && (
              <SwitchInfo
                boxDetails={boxDetails}
                systemStatus={systemStatus}
                loadingStatus={sysLoading}
                onReloadStatus={onReloadStatus}
              />
            )}
            {active === 'connectionTest' && (
              <ConnectionTests
                speedBoxDisable={speedBoxDisable}
                speedBox={boxDetails?.lteSpeedtest}
                speedTestInfo={speedTestInfo}
                speedDataInfo={speedDataInfo}
                boxVpnAddress={boxDetails?.vpnAddress}
                onDetailBtn={onDetailBtn}
                onReloadBox={onReloadBox}
              />
            )}
          </div>
        </Col>
      </Row>
      <AddSecurityCodeModal
        isOpen={modalStatus}
        onCancel={() => {
          setModalStatus(!modalStatus);
        }}
        onConfirm={() => {
          setModalStatus(!modalStatus);
          onTabChange('diagnostics');
        }}
        diagnostics
        featureName={'diagnostics'}
      />
    </div>
  );
}

const mapStateToProps = state => {
  return {
    sysinfo: state.UIState.epikBoxes.sysInfo || {},
    boxDetails: state.AppState.boxDetails.box,
    user: state.AppState.user,
  };
};

const mapDispatchToProps = dispatch => ({
  getSysInfo: (token, boxId, type) => dispatch(getSysInfo(token, boxId, type)),
  inititateSysInfo: (token, boxId, type) => dispatch(inititateSysInfo(token, boxId, type)),

  getSystemStatus: (token, boxId) => dispatch(BoxesActions.getSystemStatus(token, boxId)),
  getEpikBoxData: (token, boxId) => dispatch(BoxesActions.getEpikBoxData(token, boxId)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(InfoToolTab);
